import { Plus } from "lucide-react";

const AddVentureButton = ({ onClick }: { onClick: () => void }) => (
  <button
    onClick={onClick}
    className="absolute top-7 right-7 md:top-10 md:right-10 z-20 bg-teal-500 hover:bg-teal-600 active:scale-95 text-white rounded-full shadow-lg p-3 transition-all focus:ring-2 focus:ring-teal-300 outline-none"
    aria-label="Add new venture"
  >
    <Plus size={28} />
  </button>
);

export default AddVentureButton;
